/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
const useCheckBookingStatus = (_:string) => {};

export default useCheckBookingStatus;
